export default {
  SET_ALLOWED_LINKS: function (state, payloads) {
    state.allowedLinks = payloads;
  }
}
